import { render, staticRenderFns } from "./FreeQuestionModal.vue?vue&type=template&id=0738cc87"
import script from "./FreeQuestionModal.vue?vue&type=script&lang=js"
export * from "./FreeQuestionModal.vue?vue&type=script&lang=js"
import style0 from "./FreeQuestionModal.vue?vue&type=style&index=0&id=0738cc87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports